<template>
  <div class="map-select">
    <google-map v-model="location" :inputBox="1"></google-map>
  </div>
</template>

<script>
import GoogleMap from '../common/GoogleMap'
import * as types from '../../store/mutation-types'
import { getServiceArea } from '../../api/serviceArea'
import { mapGetters } from 'vuex'
export default {
  components: {
    GoogleMap
  },
  name: 'map-select',
  data() {
    return {
      mapType: '0',
      location: {}
    }
  },
  created() {
    console.log('this.serviceDetail.uid:', this.serviceDetail)
    getServiceArea(this.serviceDetail.uid)
      .then(res => {
        console.log('location:', res.location)
        this.location = res.location
      })
      .catch(e => {
        console.log('error', e)
      })
  },
  watch: {
    location(value) {
      console.log('chagne', value)
      this.$store.dispatch(types.SET_REQUEST_USER_BOOKING, { location: value })
    }
  },
  computed: {
    ...mapGetters(['serviceDetail'])
  }
}
</script>

<style lang="scss" scoped>
.map-select {
  height: 400px;
  width: 90%;
  /*border: 1px solid red;*/
  .map-type {
    display: flex;
    .sui-checkbox {
      width: 200px;
      border: 1px solid red;
    }
  }
  .google-map {
    width: 100%;
    height: inherit;
  }
}
</style>
